<template>
    <div>
        <dashboard-section-title>{{ $t('Current quests') }}</dashboard-section-title>

        <template v-if="quests && quests.length">
            <template v-for="(quest, index) in questCards">
                <quest-card
                    :key="`current-quest-${quest.startDate.date}${quest.id}${index}`"
                    :quest="quest"
                    :label="$t('Active')"
                    :quest-participants-label="$t('Volunteers')"
                    :hide-participants-info="quest.pointsApplyStrategy == 'scan'"
                    color="secondary"
                    class="mb-5"
                />
            </template>
        </template>

        <v-card v-else flat>
            <v-skeleton-loader type="article" />
        </v-card>
    </div>
</template>

<script>
import { ActivityModel } from '../models';
import QuestCard from './QuestCard';
import { mapState } from 'vuex';

export default {
    components: {
        QuestCard,
    },
    props: {
        quests: Array,
    },
    computed: {
        ...mapState('organization', ['selectedOrganizationID']),
        questCards() {
            return this.quests ? ActivityModel.prepareActivitiesStartDate(this.quests) : [];
        },
    },
};
</script>
